import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import classnames from 'classnames'
import { browserHistory } from 'react-router'

import { updateSettings } from '_modules/settings/actions'
import { planTypes } from '_utils/planType'
import DurationInput from '_components/durationInput'

import styles from './styles.css'

const mapStateToProps = ({ settings, user }) => ({
  settings,
  user,
})

const mapDispatchToProps = {
  updateSettings,
}

class Settings extends PureComponent {
  static propTypes = {
    settings: ImmutableProptypes.map,
    user: ImmutableProptypes.map,
    updateSettings: PropTypes.func.isRequired,
  }

  static defaultProps = {
    settings: new Map(),
    user: new Map(),
  }

  state = {
    sound: false,
    flexibleTime: false,
    timeInterval: 15,
    trackEngagement: false,
    tomorrowSection1: '',
    tomorrowSection2: '',
    tomorrowSection3: '',
    tomorrowSection4: '',
    planType: 100,
    autoStatus: null,
  }

  componentDidMount() {
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
  }

  getState = props => {
    const { settings, user } = props
    this.setState({
      sound: settings.get('sound', false),
      flexibleTime: settings.get('flexibleTime', false),
      trackEngagement: settings.get('trackEngagement', false),
      timeInterval: settings.get('timeInterval', 15) * 1,
      tomorrowSection1: settings.get('tomorrowSection1', ''),
      tomorrowSection2: settings.get('tomorrowSection2', ''),
      tomorrowSection3: settings.get('tomorrowSection3', ''),
      tomorrowSection4: settings.get('tomorrowSection4', ''),
      planType: user.get('planType', 100) * 1,
      autoStatus: settings.get('autoStatus', true),
    })
  }

  onCheckboxChange = event => {
    const { name } = event.target

    this.setState({ [name]: !this.state[name] }, () => {
      this.props.updateSettings(this.state)
    })
  }

  onFieldChange = event => {
    let { name, value } = event.target

    this.setState({ [name]: value }, () => {
      this.props.updateSettings(this.state)
    })
  }

  onDurationChange = timeInterval => {
    if (timeInterval === 0) timeInterval = 15
    this.setState({ timeInterval }, () => this.props.updateSettings(this.state))
  }

  onBookClick = event => {
    window.open(
      'https://www.amazon.com/Designing-Your-Life-Well-Lived-Joyful-ebook/dp/B01BJSRSEC/ref=sr_1_1?ie=UTF8&qid=1544467024&sr=8-1&keywords=designing+your+life+book',
      '_blank'
    )
  }

  checkLock = () => {
    const { planType } = this.state
    if (planType < planTypes.pro) browserHistory.push('/subscribe')
  }

  render() {
    const {
      sound,
      trackEngagement,
      flexibleTime,
      timeInterval,
      planType,
      tomorrowSection1,
      tomorrowSection2,
      tomorrowSection3,
      tomorrowSection4,
    } = this.state

    return (
      <div className={classnames(styles.Grid, styles['Grid--alignCenter'], styles.main)}>
        <div className={classnames(styles['Grid-cell'], styles['u-sizeFit'])}>
          <div
            className={classnames(styles.Grid, styles['u-sizeFit'], styles['settings-container'])}
          >
            <div className={classnames(styles['Grid-cell'], styles.item)}>
              <div className={classnames(styles['Grid-cell'], styles.item)}>
                <p className={classnames(styles['sub-item'])}>Time Interval</p>
                <DurationInput
                  type="text"
                  name="timeInterval"
                  value={timeInterval}
                  onChange={this.onDurationChange}
                  className={classnames(styles['sub-item'], styles.input)}
                />
              </div>
              <input
                type="checkbox"
                name="sound"
                checked={sound}
                onChange={this.onCheckboxChange}
                className={classnames(styles['sub-item'])}
              />
              <p className={classnames(styles['sub-item'])}>Sound</p>
            </div>
            <div
              role="link"
              tabIndex={0}
              className={classnames(styles['Grid-cell'], styles.lockLink)}
              onClick={this.checkLock}
            >
              <div
                className={classnames(styles['Grid-cell'], [
                  planType < planTypes.pro && styles.locked,
                ])}
              >
                <div className={classnames(styles['Grid-cell'], styles.item)}>
                  <input
                    type="checkbox"
                    name="trackEngagement"
                    checked={trackEngagement}
                    onChange={this.onCheckboxChange}
                    className={classnames(styles['sub-item'])}
                  />
                  <p className={classnames(styles['sub-item'])}>
                    Track Designing Your Life Engagement *
                  </p>
                </div>
                <div className={classnames(styles['Grid-cell'], styles.item)}>
                  <input
                    type="checkbox"
                    name="flexibleTime"
                    checked={flexibleTime}
                    onChange={this.onCheckboxChange}
                    className={classnames(styles['sub-item'])}
                  />
                  <p className={classnames(styles['sub-item'])}>Flexible Time</p>
                </div>
              </div>
              <div className={classnames(styles.terms)}>
                * Designing Your Life Engagement is based on{' '}
                <a className={classnames(styles.hilight)} onClick={this.onBookClick}>
                  Designing Your Life
                </a>{' '}
                by Bill Burnett and Dave Evans
              </div>
              {planType < planTypes.pro && (
                <div className={classnames(styles['Grid-cell'], styles.lockIcon)}>
                  <i size={40} className={classnames('fa fa-lock')} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings)



// WEBPACK FOOTER //
// ./src/views/settings/index.js